import React, { useContext } from "react";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
//import TelegramIcon from "@mui/icons-material/Telegram";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

const columns = [
  { field: "id", header: "ID", width: "7rem" },
  { field: "nombre", header: "Nombre" },
  { field: "numero", header: "Número" },
  { field: "clave", header: "Clave", width: "9rem" },
  { field: "registrado", header: "Registrado", type: "bool", width: "9rem" },
  { field: "habilitado", header: "Habilitado", type: "bool", width: "9rem" },
  {
    field: "whatsapp",
    header: "WhatsApp",
    type: "bool",
    width: "9rem",
    sortable: false,
    value: (row, { configuracion }) =>
      Boolean(configuracion && configuracion.whapi && row.numero),
  },
];

const fields = [
  { name: "nombre", label: "Nombre", type: "text", required: true, md: 12 },
  { name: "numero", label: "Número", type: "text", required: true, md: 12 },
  { name: "registrado", label: "Registrado", type: "switch" },
  { name: "habilitado", label: "Habilitado", type: "switch" },
];

/*
const acciones = [
  {
    label: "Telegram",
    icon: <TelegramIcon />,
    color: "success",
    tooltip: "Link Telegram",
    onClick: ({ toast, configuracion }) =>
      toast.show({
        severity: "info",
        summary: "Link Telegram",
        detail:
          configuracion && configuracion.destinatario === 4
            ? "https://t.me/MasteredMito_bot"
            : null,
        sticky: true,
      }),
  },
];
*/

export default function Telefonos() {
  const {
    telefonos,
    obtenerTelefonos,
    agregarTelefono,
    actualizarTelefono,
  } = useContext(ConfiguracionContext);

  return (
    <MaestroArchivo
      titulo="Teléfonos"
      entidad="teléfono"
      layout="Telefonos"
      icono={<PhoneOutlinedIcon />}
      items={telefonos}
      columns={columns}
      fields={fields}
      nuevoDefault={{
        token: null,
        numero: "",
        registrado: false,
        habilitado: true,
      }}
      onObtener={() => obtenerTelefonos({ todos: true })}
      onAgregar={(data) => agregarTelefono({ telefono: data })}
      onActualizar={(data) => actualizarTelefono({ telefono: data })}
    />
  );
}
